module.exports = __webpack_public_path__ + "img/size-fingers.32f73627.png";